// @ts-nocheck
import React from 'react'
import cx from 'classnames'
import illustrations from 'images/illustrations/'
import * as R from 'ramda'

const Illustration = ({ name, className, ...props }) => {
  const src = illustrations[name]
  const [loaded, setLoaded] = React.useState(false)
  const imgLoadHandler = React.useCallback(
    ev => {
      setLoaded(true)
    },
    [setLoaded],
  )
  if (!src)
    throw Error(
      `could not load image ${name}. ${JSON.stringify(
        R.toPairs(illustrations),
      )}`,
    )

  return (
    <img
      className={cx('Illustration', className, { loaded })}
      onLoad={imgLoadHandler}
      src={src}
      alt={name}
      {...props}
    />
  )
}

export default Illustration
